import { render } from "./ReLoginPage.vue?vue&type=template&id=16277e9c&ts=true"
import script from "./ReLoginPage.vue?vue&type=script&lang=ts"
export * from "./ReLoginPage.vue?vue&type=script&lang=ts"

import "./ReLoginPage.vue?vue&type=style&index=0&id=16277e9c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__